import { useState } from "react";

const PLACEHOLDER_PHOTO_MARKERS = [
  "/assets/images/people2.png",
  "/assets/images/people.png",
  "/assets/images/Avatar.png",
];

const SIZE_CLASSES = {
  sm: { box: "size-9", text: "text-xs" },
  md: { box: "size-24", text: "text-2xl" },
  lg: { box: "size-[144px]", text: "text-5xl" },
};

export function getUserInitials({ firstName, lastName, username, email } = {}) {
  const first = String(firstName || "").trim();
  const last = String(lastName || "").trim();
  if (first && last) return `${first[0]}${last[0]}`.toUpperCase();
  if (first) return first.slice(0, 2).toUpperCase();
  if (last) return last.slice(0, 2).toUpperCase();
  const fallback = String(username || email || "").trim();
  if (fallback) return fallback.slice(0, 2).toUpperCase();
  return "?";
}

export function isRealProfilePicture(url) {
  if (!url || typeof url !== "string") return false;
  const trimmed = url.trim();
  if (!trimmed) return false;
  if (trimmed.startsWith("blob:")) return true;
  return !PLACEHOLDER_PHOTO_MARKERS.some((marker) => trimmed.includes(marker));
}

export default function UserAvatar({
  src,
  firstName,
  lastName,
  username,
  email,
  size = "md",
  className = "",
  alt = "",
}) {
  const [failed, setFailed] = useState(false);
  const showImage = isRealProfilePicture(src) && !failed;
  const initials = getUserInitials({ firstName, lastName, username, email });
  const sizeClasses = SIZE_CLASSES[size] || SIZE_CLASSES.md;

  if (showImage) {
    return (
      <img
        src={src}
        alt={alt}
        className={`${sizeClasses.box} shrink-0 rounded-full object-cover border border-gray-100 bg-gray-50 ${className}`}
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <div
      aria-hidden={alt ? undefined : true}
      aria-label={alt || undefined}
      className={`${sizeClasses.box} shrink-0 rounded-full border border-gray-100 bg-darkblue text-white flex items-center justify-center font-semibold uppercase ${sizeClasses.text} ${className}`}
    >
      {initials}
    </div>
  );
}
